const routes = [
  {
    path: '/carApprovalRecord',
    name: 'carApprovalRecord',
    component: () => import('./pages/index'),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  }
]
export default routes